export enum Vertical {
  Hunt = 'hunt',
  Offroad = 'offroad',
  Backcountry = 'backcountry',
  Fish = 'fish',
}
